import { ERROR_MESSAGES } from '../constants';
import mergeWith from 'lodash.mergewith';

export function baseReducer(state: StoreState, action: Action): StoreState {
  switch (action.type) {
    case 'UPDATE_VALUE': {
      const update = typeof action.data === 'function' ? action.data(state) : action.data;

      // Merge objects, replace arrays
      return mergeWith({}, state, update, (objValue, srcValue) => {
        if (Array.isArray(srcValue)) {
          return srcValue;
        }
      });
    }
    case 'REPLACE_CART': {
      // Why cart applies don't go through UPDATE_VALUE: docs/agent/react-store-architecture.md.
      return { ...state, cart: action.data.cart };
    }
    case 'SHOW_ERROR': {
      if (!action.data.body) action.data.body = ERROR_MESSAGES.DEFAULT;
      const { title = 'Oops!', body = action.data.body, button = 'Try again', step } = action.data;

      return {
        ...state,
        error: { title, body, button, ...action.data },
        modalOpen: 'ERROR',
        loading: false,
        isProcessing: false,
        ...(step !== undefined ? { step } : {}),
      };
    }
    case 'PROCESSING':
      return {
        ...state,
        isProcessing: true,
      };
    case 'SET_SHIPPING_METHOD':
      const isBillingPromo = Number(action.data.cart.totals.total) === 0;
      let paymentMethod = state.paymentMethod;
      if (isBillingPromo) {
        paymentMethod = 'free';
      } else {
        if (
          state.account.paymentMethods.length &&
          paymentMethod !== 'paypal' &&
          paymentMethod !== 'applepay' &&
          // Without this a vaulted-card customer's Google Pay choice is silently swapped for
          // saved_payment on shipping change.
          paymentMethod !== 'googlepay'
          // TODO remove this entire block, don't think there is any reason to set saved_payment as method before step 3
        ) {
          paymentMethod = 'saved_payment';
        }
      }
      return {
        ...state,
        isProcessing: false,
        isBillingPromo,
        ...action.data,
        paymentMethod,
      };

    case 'SET_BRAINTREE_INSTANCE':
      return {
        ...state,
        ...action.data,
      };

    case 'NEXT_STEP':
      return {
        ...state,
        step: action.data.step,
      };
    default:
      return state;
  }
}
